import { render, staticRenderFns } from "./BoxContent4.vue?vue&type=template&id=1b589354&scoped=true"
import script from "./BoxContent4.vue?vue&type=script&lang=js"
export * from "./BoxContent4.vue?vue&type=script&lang=js"
import style0 from "./BoxContent4.vue?vue&type=style&index=0&id=1b589354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b589354",
  null
  
)

export default component.exports